import StatCard from '@/components/stats/StatCard';
import StatCardSkeleton from '@/components/stats/StatCardSkeleton';
import { useAuth } from '@/contexts/auth-context';
import { useAffiliateInvitationStatsQuery } from '@/hooks/queries/use-affiliate-invitation-stats-query';
import { Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface InvitationStatsCardsProps {
  programId?: string;
}

const CARD_PROPS = {
  minWidth: '180px',
  flex: 1,
  height: '112px',
  border: '1px solid',
  borderColor: 'gray.200',
};

const InvitationStatsCards: React.FC<InvitationStatsCardsProps> = ({ programId }) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { data, isLoading, isFetching } = useAffiliateInvitationStatsQuery(user?.currentBrandId, {
    programId,
  });

  if (isLoading) {
    return (
      <Flex gap={2} overflowX="auto" pb={2} width="100%">
        {Array.from({ length: 3 }).map((_, index) => (
          <StatCardSkeleton key={`invitation-stat-skeleton-${index}`} />
        ))}
      </Flex>
    );
  }

  return (
    <Flex gap={2} overflowX="auto" pb={2} width="100%" justifyContent="space-between">
      <StatCard
        title={t('invitations.stats.total')}
        description={t('invitations.stats.totalDescription')}
        value={data?.total ?? 0}
        isLoading={isFetching}
        {...CARD_PROPS}
      />
      <StatCard
        title={t('invitations.stats.pending')}
        description={t('invitations.stats.pendingDescription')}
        value={data?.pending ?? 0}
        isLoading={isFetching}
        {...CARD_PROPS}
      />
      <StatCard
        title={t('invitations.stats.accepted')}
        description={t('invitations.stats.acceptedDescription')}
        value={data?.accepted ?? 0}
        isLoading={isFetching}
        {...CARD_PROPS}
      />
    </Flex>
  );
};

export default InvitationStatsCards;
